import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { setFiles, setPartnerProfileImages } from "../shared/sharedSlice";
import { notify } from "../../../utils/shared";
const API_URL = process.env.REACT_APP_API_URL;
const GET_ALL_VIDEO = `${API_URL}/videos`;
const ADD_VIDEO_DETAILS = `${API_URL}/videos`;
const UPDATE_VIDEO_DETAILS = `${API_URL}/videos`;
const PAIR_IMEI_FROM_MONITOR = `${API_URL}/videos/pairImeiFromMontior`;
const APPROVE_VIDEO = `${API_URL}/videos/approve/`;
const COMMON_FILE_UPLOAD = `${API_URL}/fileUpload`;

export const getVideos = createAsyncThunk(
  "getVideos",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      let user: any = localStorage.getItem('kt-auth-react-v');
      user = JSON.parse(user);
      const { page, limit, search = '' } = values
      const { data } = await axios.get(`${GET_ALL_VIDEO}?page=${page}&limit=${limit}&search=${search}`, {headers: {authorization: user.token}});
      return data;
    } catch (error: any) {
      const { responseMessage } = error?.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const commonFileUpload = createAsyncThunk(
  "commonFileUpload",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios({
        method: "post",
        url: `${COMMON_FILE_UPLOAD}`,
        data: values,
        headers: { "Content-Type": "multipart/form-data" },
      })
      dispatch(setFiles(data))
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const partnerProfileImage = createAsyncThunk(
  "commonFileUpload",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios({
        method: "post",
        url: `${COMMON_FILE_UPLOAD}`,
        data: values,
        headers: { "Content-Type": "multipart/form-data" },
      })
      dispatch(setPartnerProfileImages(data))
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const updateVideoDetails = createAsyncThunk(
  "updateVideoDetails",
  async (values: any, { rejectWithValue, dispatch, getState }) => {
    try {
      let selectedPage = values.get("selectedPage")
      let user: any = localStorage.getItem('kt-auth-react-v');
      user = JSON.parse(user);
      const { data } = await axios.put(`${UPDATE_VIDEO_DETAILS}/${values.get("id")}`, values, {headers: {authorization: user.token}});
      notify(data.responseMessage, 'success');
      const pageSize = (getState() as any).videoList?.pageSize ?? 100;
      dispatch(getVideos({ page: selectedPage || 1, limit: pageSize }));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const changeVideoStatus = createAsyncThunk(
  "changeVideoStatus",
  async (values: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const { data } = await axios.put(`${UPDATE_VIDEO_DETAILS}${values?._id}`, { isVerified: !values?.isVerified });
      notify(data.responseMessage, 'success');
      const pageSize = (getState() as any).videoList?.pageSize ?? 100;
      dispatch(getVideos({ page: values.selectedPage || 1, limit: pageSize }));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const addVideoDetail = createAsyncThunk(
  "addVideoDetail",
  async (values: any, { rejectWithValue, dispatch, getState }) => {
    try {
      let selectedPage = values.get("selectedPage");
      let isScanned = values.get("isScanned");
      let user: any = localStorage.getItem('kt-auth-react-v');
      user = JSON.parse(user);
      const { data } = await axios.post(`${ADD_VIDEO_DETAILS}`, values, {headers: {authorization: user.token}});
      
      // Log if data was added by scanning
      if (isScanned === 'true') {
        console.log('Video detail added via scanning');
      }
      
      notify(data.responseMessage, 'success');
      const pageSize = (getState() as any).videoList?.pageSize ?? 100;
      dispatch(getVideos({ page: selectedPage || 1, limit: pageSize }))
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const pairImeiFromMonitor = createAsyncThunk(
  "pairImeiFromMonitor",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      let user: any = localStorage.getItem('kt-auth-react-v');
      user = JSON.parse(user);
      const { data } = await axios.post(`${PAIR_IMEI_FROM_MONITOR}`, values, {headers: {authorization: user.token}});
      
      notify(data.responseMessage, 'success');
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);


export const deleteVideo = createAsyncThunk(
  "deleteVideo",
  async (values: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const { data } = await axios.delete(`${UPDATE_VIDEO_DETAILS}/${values.id}`);
      notify(data.responseMessage, 'success');
      const pageSize = (getState() as any).videoList?.pageSize ?? 100;
      dispatch(getVideos({ page: values.selectedPage || 1, limit: pageSize }));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);
